import { Z3kRoutes } from 'z3k-settings/routes/type';
export var Z3KTabId;
(function (Z3KTabId) {
    Z3KTabId["settings"] = "settings";
    Z3KTabId["access"] = "access";
    Z3KTabId["analog_inputs"] = "analog_inputs";
    Z3KTabId["wired_temperature_sensors"] = "wired_temperature_sensors";
    Z3KTabId["guard_zones"] = "guard_zones";
    Z3KTabId["notifications"] = "notifications";
    Z3KTabId["users"] = "users";
    Z3KTabId["output_actions"] = "output_actions";
    Z3KTabId["radiomodules"] = "radiomodules";
    Z3KTabId["radiosensors"] = "radiosensors";
    Z3KTabId["fobs"] = "fobs";
    Z3KTabId["radiorelays"] = "radiorelays";
    Z3KTabId["managed_mechanisms"] = "managed_mechanisms";
    Z3KTabId["scenarios"] = "scenarios";
    Z3KTabId["heating_circuits"] = "heating_circuits";
    Z3KTabId["heating_modes"] = "heating_modes";
    Z3KTabId["io_extensions"] = "io_extensions";
    Z3KTabId["web_elements"] = "web_elements";
    Z3KTabId["service"] = "service";
    Z3KTabId["duts"] = "duts";
    Z3KTabId["diag"] = "diag";
    Z3KTabId["ui"] = "ui";
    Z3KTabId["modbus_devices"] = "modbus_devices";
    Z3KTabId["z3k_config"] = "z3k_config";
    Z3KTabId["mqtt_topics"] = "mqtt_topics";
})(Z3KTabId || (Z3KTabId = {}));
export const goToPage = [
    [Z3kRoutes.settings, []], // на будущее
    [Z3kRoutes.access, []], // на будущее
    [Z3kRoutes.sensors, ['Входы', 'Датчики']],
    [
        Z3kRoutes.temperature_sensors,
        ['Цифровые термодатчики', 'Аналоговые термодатчики'],
    ],
    [Z3kRoutes.guard_zones, ['Охранные зоны', 'Ключи TM']],
    [Z3kRoutes.notifications, ['Оповещения']],
    [Z3kRoutes.users, ['Пользователи', 'Роли']],
    [Z3kRoutes.output_actions, ['Действия с выходом']],
    [
        Z3kRoutes.radiomodules,
        ['Радиоустройства', 'Радиодатчики', 'Радиодатчики 433МГц'],
    ],
    [
        Z3kRoutes.managed_mechanisms,
        [
            'Адаптеры котлов',
            'Управляемые механизмы / Релейные управления',
            'Релейные управления',
            'Управляемые механизмы / Насосы',
            'Насосы',
            'Управляемые механизмы / Краны смесителей',
            'Краны смесителей',
            'Сирены',
            'Индикаторы охраны',
        ],
    ],
    [Z3kRoutes.scenarios, ['Сценарии']],
    [Z3kRoutes.heating_circuits, ['Отопительные контуры']],
    [Z3kRoutes.heating_modes, []], // на будущее
    //[Z3kRoutes.io_extensions, []], // на будущее
    [Z3kRoutes.web_elements, ['Элементы управления']], // на будущее
    [Z3kRoutes.service, []], // на будущее
    [Z3kRoutes.modbus_devices, ['modbus_devices']],
];
